import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/Header.css';
import logo from '../assets/logo.png';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, anchor: string) => {
    e.preventDefault();
    const anchorId = anchor.replace('#', '');
    
    if (location.pathname !== '/') {
      // If not on home page, navigate to home first
      navigate('/');
      // Scroll to anchor after navigation completes
      // Use a longer timeout to ensure the page has rendered
      setTimeout(() => {
        const scrollToAnchor = () => {
          const element = document.getElementById(anchorId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          } else {
            // Retry if element not found yet
            setTimeout(scrollToAnchor, 50);
          }
        };
        scrollToAnchor();
      }, 200);
    } else {
      // If on home page, just scroll to anchor
      const element = document.getElementById(anchorId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    
    // Close mobile menu if open
    setMenuOpen(false);
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container header-container">
        <div className="logo-container">
          <img src={logo} alt="KMD Classic Logo" className="logo" />
          <h1>Komodo Classic</h1>
        </div>
        
        <div className="mobile-menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        
        <nav className={`main-nav ${menuOpen ? 'open' : ''}`}>
          <ul>
            <li><a href="#features" onClick={(e) => handleNavClick(e, '#features')}>Features</a></li>
            <li><a href="#history" onClick={(e) => handleNavClick(e, '#history')}>History</a></li>
            <li><a href="#donations" onClick={(e) => handleNavClick(e, '#donations')}>Donations</a></li>
            <li><a href="https://github.com/kmdclassic/KmdClassic/releases/latest" target="_blank" rel="noopener noreferrer">Wallet</a></li>
            <li><a href="/" className="btn btn-primary" onClick={(e) => { 
              e.preventDefault(); 
              navigate('/'); 
              setMenuOpen(false);
              // Scroll to top after navigation
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }, 100);
            }}>KMDCL</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
